import React, { useState } from 'react'
import { TextField } from 'foundations-library/components'
import { TextFieldType } from 'foundations-library/types'

/**
 *
 */
const PasswordTextField = (props: TextFieldType): JSX.Element => {
    const [isVisible, setIsVisible] = useState(false)

    const toggleVisibility = () => setIsVisible((prev) => !prev)

    return <TextField
        {...props}
        type={isVisible ? 'text' : 'password'}
        trailingIcon={isVisible ? 'visibility-off' : 'visibility'}
        onClickTrailingIcon={toggleVisibility}
    />
}

export default PasswordTextField
